import { memo } from 'react';
import SpanFeedbackTaskComponent from './SpanFeedbackTaskComponent';
import { StepViewComponentProps } from '../stepDescriptor/types';

function SpanFeedbackViewComponent(props: StepViewComponentProps) {
  return <SpanFeedbackTaskComponent {...props} isPinnable isPinnedView={false} />;
}

export default memo(SpanFeedbackViewComponent);
